'use strict';

namespace Core {

    interface FlightSegmentInfo {
        AirportCode:string;
        FlightNumber:string;
        CarrierTradingName:string;
    }

    interface FlightViaInfo {
        viaflight : string;
        operatedBy : string;
    }

    class FlightLeg {

        leg: any;
        displayMixedCarrierMessage: boolean;
        displayFlightViaInfo: boolean;
        displayCodeShareInfo: boolean;
        isFlightsPage: boolean = false;
        viaInfo: FlightViaInfo[];
        mixedCarrierMessage: string;


        constructor( public resourceService:ResourceService, public $filter: any ) {

            this.displayFlightViaInfo = TRPCONFIG.Domain.DisplayFlightViaInfo && this.leg.Segments
            && this.leg.Segments.length > 0;

            this.displayMixedCarrierMessage = this.leg.IsMixedCarrier &&
                                              this.leg.NumberOfStops > 0 &&
                                              this.displayFlightViaInfo === false;

            this.displayCodeShareInfo = TRPCONFIG.Domain.DisplayFlightCodeshareInfo || false;

            this.isFlightsPage = window.location.pathname.includes('flights')
            || window.location.pathname.includes('quote');

            if( this.displayMixedCarrierMessage ) {
                this.mixedCarrierMessage = this.resourceService.get('OPERATEDBYMIXED');
            }

            if (this.displayFlightViaInfo || this.displayCodeShareInfo)  {
                this.viaInfo = this.getFlightViaInfo();
            }

        }

        getNumberOfStops() {

            var msg = this.resourceService.get('NOSTOP');
            if( this.leg.NumberOfStops === 1 ) {
                msg = this.resourceService.get('1STOP');
            } else if( this.leg.NumberOfStops > 1 ) {
                msg = String.format(this.resourceService.get('XSTOPS'),this.leg.NumberOfStops);
            }
            return msg;
        }

        getFlightViaInfo():FlightViaInfo[] {
                const info: FlightSegmentInfo[] = [];

                angular.forEach( this.leg.Segments, (segment, i) => {
                    if( segment.CodeshareAirlineName !== segment.CarrierName ) {
                        let carrier = segment.CarrierTradingName;
                        if (segment.CarrierTradingName === '') {
                            carrier = segment.CarrierName;
                        }

                        info.push({
                                AirportCode: this.leg.LegType === 'outbound'
                                    ? segment.DestinationAirportCode
                                    : segment.DepartureAirportCode,
                                FlightNumber: segment.FlightNumber,
                                CarrierTradingName: carrier
                        });
                    }
                });

                return info.map(item => {

                    let tradingName = '';
                    if( item.CarrierTradingName && item.CarrierTradingName !== '') {
                        tradingName = item.CarrierTradingName.toLowerCase();
                    }

                    return {
                        viaflight : String.format(this.resourceService.get('VIASUMMARY'),
                            item.FlightNumber),
                        operatedBy : String.format(this.resourceService.get('OPERATEDBYSUMMARY'),
                            '<span class="trading-name">'+ tradingName +'</span>')
                    };
                });
        }
    }

    angular
        .module('core')
        .directive('flightLeg', ($filter): ng.IDirective => {
            return {
                scope: {},
                restrict: 'E',
                replace: true,
                bindToController: {
                    leg: '='
                },
                controller: FlightLeg,
                controllerAs: 'fl',
                templateUrl: 'partials/home/directivetemplate?type=FlightLeg',
                link: function (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : FlightLeg) {
                }

            };

        });

}
